import './parts/header';

import {
    gsap,
    Power1,
    Power3
} from "gsap";

import {
    ScrollTrigger
} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import Swiper from 'swiper';
import {
    Navigation,
} from 'swiper/modules';

function windowWidth() {
    return window.innerWidth;
}

(function() {

    if (windowWidth() < 992) return;

    let secTtlAnimLate = document.querySelectorAll(".secTtlAnim-late");
    if (secTtlAnimLate[0]) {
        let position = windowWidth() < 767 ? '20% 35%' : '20% 35%'
        gsap.utils.toArray(secTtlAnimLate).forEach(seq => {
            gsap.from(seq, {
                opacity: 0,
                y: 50,
                scrollTrigger: {
                    trigger: seq,
                    scrub: 1,
                    start: position,
                    end: "bottom 75%",
                },
            })
        })
    }

    let animateSimple = document.querySelectorAll('.product-tabs__item, .list-lines__item, .list-icons__item');
    if (animateSimple.length > 0) {
        gsap.utils.toArray('.list-lines__item, .list-icons__item').forEach(item => {
            gsap.from(item, {
                duration: 0.9,
                y: 200,
                autoAlpha: 1,
                ease: Power3.out,
                stagger: .05,
                scrollTrigger: {
                    trigger: item.parentElement,
                    scrub: 1,
                    start: "top 95%",
                    end: "70% 70%",
                },
            })
        })
    }

}());


let aboutTitle = document.querySelector('.js-about-title');
let aboutImage = document.querySelector('.js-about-image');
let fixedImage = document.querySelector('.js-fixed-image');
let aboutDecor = document.querySelector('.js-product-about-decor');

window.addEventListener('scroll', animationsOnScroll);

animationsOnScroll();

function animationsOnScroll() {
    let scroll = window.scrollY || document.documentElement.scrollTop;

    //console.log('scroll: ' + scroll);

    if (fixedImage) {
        animateFixedImage(scroll, fixedImage);
    }

    let sectionAbout = document.querySelector('.product-about');
    let sectionAboutPosition = isElementInViewport(sectionAbout);

    animateAbout(scroll, sectionAboutPosition.percentage);
}

function animateAbout(scroll, percentage){
    if (aboutTitle) {
        aboutTitle.style.transform = percentage && (percentage < 0 || percentage >= 80) ? 'scale(1)' : 'scale(0)';
    }
    if (aboutImage) {
        aboutImage.style.opacity = percentage && (percentage < 0 || percentage >= 96) ? 1 : 0;
        aboutImage.style.top = percentage && (percentage < 0 || percentage >= 96) ? '-10px' : 0;
    }

    if (fixedImage) {
        if (scroll < 200) {
            fixedImage.style.opacity = 1;

        } else {
            fixedImage.style.opacity = percentage && (percentage < 0 || percentage >= 97) ? 0 : 1;
        }
    }

    if (aboutDecor) {
        aboutDecor.style.transform = percentage && (percentage < 0 || percentage >= 80) ? 'scale(1)' : 'scale(0)';
    }
}

function animateFixedImage(scroll, div){

    let windowHeight = window.innerHeight;

    if (scroll <= 5) {
        div.style.transform = 'rotate(16deg)';
        div.style.width = '400px';
        div.style.height = '600px';
        div.style.bottom = '-175px';
    }

    if (scroll > 5) {
        div.style.transform = 'rotate(' + interpolate(16, 0, 5, 200, scroll) + 'deg)';
        div.style.height = interpolate(600, 440, 5, 200, scroll) + 'px';
        div.style.width = interpolate(400, 275, 5, 200, scroll) +  + 'px';
        div.style.bottom = interpolate(-175, 90, 5, 200, scroll) + 'px';
    }
}

function interpolate(start, end, startPoint, endPoint, value) {
    let progress = (value - startPoint) / (endPoint - startPoint);
    if (value <= startPoint) return start;
    if (value >= endPoint) return end;
    return start + (end - start) * progress;
}

function isElementInViewport(div) {
    let rect = div.getBoundingClientRect();

    let windowHeight = window.innerHeight || document.documentElement.clientHeight;
    let distanceFromTop = rect.top;
    //let percentage = distanceFromTop >= 0 ? (windowHeight - distanceFromTop) / windowHeight * 100 : - ((windowHeight + distanceFromTop) / windowHeight * 100);
    let percentage = distanceFromTop >= 0 ? (windowHeight - distanceFromTop) / windowHeight * 100 : distanceFromTop;

    return {
        top: rect.top,
        bottom: rect.bottom,
        percentage: parseInt(percentage)
    };
}

(function() {
    let lFollowX = 0,
        lFollowY = 0,
        x = 0,
        y = 0,
        friction = 1 / 30;

    function moveBackground() {

        x += (lFollowX - x) * friction;
        y += (lFollowY - y) * friction;
        let translate = 'translateX(' + x + 'px) translateY(' + y + 'px)';

        document.querySelectorAll('.animate-this').forEach(function(element){
            element.style.webkitTransform = translate;
            element.style.mozTransform = translate;
            element.style.transform = translate;
        });

        window.requestAnimationFrame(moveBackground);
    }

    let animWrapper = document.querySelector('.anim-wrapper');
    animWrapper.addEventListener('mousemove', function(e) {
        let lMouseX = Math.max(-100, Math.min(100, animWrapper.offsetWidth / 2 - e.clientX)),
            lMouseY = Math.max(-100, Math.min(100, animWrapper.offsetHeight / 2 - e.clientY));
        lFollowX = (20 * lMouseX) / 100;
        lFollowY = (10 * lMouseY) / 100;
    });

    animWrapper.addEventListener('mouseleave', function() {
        lFollowX = 0;
        lFollowY = 0;
    });

    moveBackground();
})();

let tabItems = document.querySelectorAll('.product-tabs__item');
tabItems.forEach(function(tabItem) {
    tabItem.addEventListener('click', function() {
        let tabId = this.getAttribute('data-id');
        let tabBodies = document.querySelectorAll('.product-tabs-body');

        tabBodies.forEach(function(tabBody) {
            if (tabBody.getAttribute('data-id') === tabId) {
                tabBody.classList.add('active');
                // if (windowWidth() > 992) {
                //     gsap.from(tabBody, {
                //         duration: 1,
                //         y: 100,
                //         autoAlpha: 1,
                //         ease: Power3.out,
                //         stagger: .05,
                //         scrollTrigger: {
                //             trigger: tabBody.parentElement,
                //             scrub: 1,
                //             start: "top 50%",
                //             end: "70% 70%",
                //         },
                //     });
                // }
            } else {
                tabBody.classList.remove('active');
            }
        });

        let allTabItems = document.querySelectorAll('.product-tabs__item');
        allTabItems.forEach(function(item) {
            item === tabItem ? item.classList.add('active') : item.classList.remove('active');
        });

        let decorStatus = this.getAttribute('data-decor');
        let productAboutDecor = document.querySelector('.js-product-about-decor');
        if (productAboutDecor) {
            //decorStatus === 'off' ? productAboutDecor.classList.add('decor-disable') : productAboutDecor.classList.remove('decor-disable');
        }

        let decorBackground = this.getAttribute('data-background');
        let productAboutBackground = document.querySelector('.js-product-about-background');
        if (productAboutBackground) {
            if (decorBackground && decorBackground.length) {
                productAboutBackground.style.backgroundImage = "url('" + decorBackground + "')";

            } else {
                productAboutBackground.style.backgroundImage = 'none';
            }
        }
    });
});

(function () {

    function productsSlider() {
        if (!document.querySelector('.expoSldr')) return;

        let prev = document.querySelector('.expoSldr .uniSliderActions__btn--prev');
        let next = document.querySelector('.expoSldr .uniSliderActions__btn--next');

        let expoSlidesQuantity = document.querySelectorAll('.expoSldr .swiper-slide').length,
            slidesMin = 5;

        let swiperItems = document.querySelectorAll('.expoSldr .swiper-slide');
        let expoSldr = new Swiper('.expoSldr .swiper-container', {
            modules: [Navigation],
            direction: 'horizontal',
            watchOverflow: true,
            slidesPerView: slidesMin,
            centeredSlides: true,
            loop: expoSlidesQuantity > slidesMin,
            navigation: {
                nextEl: next,
                prevEl: prev
            },
            on: {
                init: function (e) {
                    swiperItems.forEach(item => {
                        item.classList.add('changed');
                    });
                },
                slideChangeTransitionStart: function (e) {
                    swiperItems.forEach(item => {
                        item.classList.add('changing');
                        item.classList.remove('changed');
                    });
                },
                slideChangeTransitionEnd: function (e) {
                    swiperItems.forEach(item => {
                        item.classList.remove('changing');
                        item.classList.add('changed');
                    });
                },
                click() {
                    expoSldr.slideTo(this.clickedIndex);
                },
            },
        });
    }
    productsSlider()

}());
